import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import dayjs from "dayjs";

import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import ReportDaily from '../../../components/report/SiteReportDaily.js';
import ReportMonthly from '../../../components/report/SiteReportMonthly.js';
import ReportYearly from '../../../components/report/SiteReportYearly.js';
import ReportCOD from '../../../components/report/SiteReportCOD.js';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import Calendar from '../../../components/calendar/Calendar.js';

import './bee-print-common.css';

function ReportSystem(props) {
    const [reportdata, setReportdata] = useState({});
    const [reportchart, setReportchart] = useState({});

    const [reporttype_picker, setReporttype_picker] = useState('day');
    const [reporttype, setReporttype] = useState('daily');
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));
    const [calendar_text, setCalendar_text] = useState('Date');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        setReportdata({})
        setReportchart({})
        if (reporttype !== undefined) {
            if (reporttype === "daily") {
                setReporttype_picker("date")
                setCalendar_text("Date")
            } else if (reporttype === "monthly") {
                setReporttype_picker("month")
                setCalendar_text("Month")
                if (dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD") === dayjs(new Date()).format("YYYY-MM-DD")) {
                    setReportdate_dt(dayjs(new Date()).subtract(1, 'day'))
                }
            } else if (reporttype === "yearly") {
                setReporttype_picker("year")
                setCalendar_text("Year")
                if (dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD") === dayjs(new Date()).format("YYYY-MM-DD")) {
                    setReportdate_dt(dayjs(new Date()).subtract(1, 'day'))
                }
            } else if (reporttype === "cod") {
                setReporttype_picker("month")
            }
        }
    }, [reporttype]);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function print_document(filename) {
        if (filename !== "-") {
            window.onbeforeprint = function (event) {
                document.title = filename
            };
            window.onafterprint = function (event) {
                document.title = 'CPF Solar Monitoring System'
            };
            window.print();
            return false
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "No data to print!",
                enable: true
            })
        }
    }

    const get_reportdate = (date) => {
        if (reporttype === "daily") {
            return dayjs(new Date(date)).format("YYYY-MM-DD")
        } else if (reporttype === "monthly") {
            return dayjs(new Date(date)).format("YYYY-MM")
        } else if (reporttype === "yearly") {
            return dayjs(new Date(date)).format("YYYY")
        } else {
            return dayjs(new Date(date)).format("YYYY")
        }
    }

    function disabledCalendar(current) {
        if (reporttype === "daily") {
            return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
        } else if (reporttype === "monthly") {
            return current.isBefore(props.permitdata.cod_date, 'month') || current.isAfter(dayjs(new Date()).subtract(1, 'days').format("YYYY-MM-DD 23:59:59"), 'month')
        } else if (reporttype === "yearly") {
            return current.isBefore(props.permitdata.cod_date, 'year') || current.isAfter(dayjs(new Date()).subtract(1, 'days').format("YYYY-MM-DD 23:59:59"), 'year')
        }
    }

    async function api_query_report(reporttype, reportdate) {
        setmodal_load({ enable: true, message: "Generating daily report." })
        await sleep(500)

        const formData = new FormData();
        formData.append('post_url', "/proxy/center/api/historical/report/" + reporttype)
        formData.append('token', props.permitdata.token)

        formData.append('reporttype', reporttype)
        if (reporttype === "daily" || reporttype === "yearly") {
            formData.append('reportdate', reportdate)
        } else if (reporttype === "monthly") {
            formData.append('reportmonth', reportdate)
        }
        formData.append('reportsite', props.permitdata.sitecode)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/report/" + reporttype, formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setReportdata(response.data.report_data)
                    setReportchart(remap_chart(reporttype, response.data.report_data?.ChartData))
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    const remap_chart = (type, chart_data) => {
        if (type === "daily") {
            let daplot = {
                EnergyAC: [],
                EnergyGrid: [],
                ENS: [],
                IRR: [],
                XLabel: chart_data.XLabel
            }
            if (chart_data.IRR !== null) {
                for (let i = 0; i < chart_data.IRR.length; i++) {
                    const dx = new Date(chart_data.EnergyAC[i].x)

                    daplot.IRR.push({ x: dx, y: chart_data.IRR[i].y })
                    daplot.EnergyAC.push({ x: dx, y: chart_data.EnergyAC[i].y })
                    daplot.EnergyGrid.push({ x: dx, y: chart_data.EnergyGrid[i].y })
                    daplot.ENS.push({ x: dx, y: chart_data.ENS[i].y })
                }
            }
            return daplot
        } else if (type === "monthly") {
            let daplot = {
                EnergyAC: [],
                EnergyEST: [],
                ENS: [],
                errorx: [],
                XLabel: chart_data.XLabel
            }
            if (chart_data.EnergyAC !== null) {
                for (let i = 0; i < chart_data.EnergyAC.length; i++) {
                    const dx = new Date(chart_data.EnergyAC[i].x)

                    daplot.EnergyAC.push({ x: dx, y: chart_data.EnergyAC[i].y })
                    daplot.EnergyEST.push({ x: dx, y: chart_data.EnergyEST[i].y })
                    daplot.ENS.push({ x: dx, y: chart_data.ENS[i].y })
                    daplot.errorx.push(chart_data.errorx[i])
                }
            }
            return daplot
        } else if (type === "yearly") {
            let daplot = {
                EnergyAC: [],
                EnergyEST: [],
                ENS: [],
                XLabel: chart_data.XLabel
            }
            if (chart_data.EnergyAC !== null) {
                for (let i = 0; i < chart_data.EnergyAC.length; i++) {
                    const dx = new Date(chart_data.EnergyAC[i].x)

                    daplot.EnergyAC.push({ x: dx, y: chart_data.EnergyAC[i].y })
                    daplot.EnergyEST.push({ x: dx, y: chart_data.EnergyEST[i].y })
                    daplot.ENS.push({ x: dx, y: chart_data.ENS[i].y })
                }
            }
            return daplot
        } else if (type === "cod") {
            let daplot = {
                EnergyAC: [],
                E100: [],
                ENS: [],
                XLabel: chart_data.XLabel
            }
            if (chart_data.EnergyAC !== null) {
                for (let i = 0; i < chart_data.EnergyAC.length; i++) {
                    const dx = new Date(chart_data.EnergyAC[i].x)

                    daplot.EnergyAC.push({ x: dx, y: chart_data.EnergyAC[i].y })
                    daplot.E100.push({ x: dx, y: chart_data.E100[i].y })
                    daplot.ENS.push({ x: dx, y: chart_data.ENS[i].y })
                }
            }
            return daplot
        }
        return {}
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2 print-disable">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-file-chart-outline color-orange"></i> System Report</h4>
                                    <p className="mb-0">Query solar production data with report template</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>
                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Type</label>
                            <select id="reporttype" name="reporttype" className="form-select" value={reporttype} onChange={(e) => {
                                setReporttype(e.target.value)
                            }} required>
                                <option value="daily">Daily</option>
                                <option value="monthly">Monthly</option>
                                <option value="yearly">Yearly</option>
                                <option value="cod">From COD</option>
                            </select>
                        </div>
                        <div className={reporttype !== "cod" ? "d-block " : "d-none"} style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select {calendar_text}</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                picker={reporttype_picker}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query_report(reporttype, get_reportdate(reportdate_dt)) }}><i className="fas fa-search me-2"></i> Query</button>
                            </div>
                            <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm" onClick={() => { print_document(reportdata.FileName) }}><i className="fas fa-print me-2"></i> Print</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        reporttype === "daily" ?
                            <ReportDaily reportdata={reportdata} reportchart={reportchart}></ReportDaily>
                            : reporttype === "monthly" ?
                                <ReportMonthly reportdata={reportdata} reportchart={reportchart}></ReportMonthly>
                                : reporttype === "yearly" ?
                                    <ReportYearly reportdata={reportdata} reportchart={reportchart}></ReportYearly>
                                    : reporttype === "cod" ?
                                        <ReportCOD reportdata={reportdata} reportchart={reportchart}></ReportCOD>
                                        :
                                        null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default ReportSystem